import { Fragment, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { consumeDashboardTokenFromUrl, hasDashboardAuthSession } from "../../utils/dashboardAuth";

export default function AuthProvider({ children }) {

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        consumeDashboardTokenFromUrl();
        const isAuthenticated = hasDashboardAuthSession();
        const isLoginRoute = location.pathname === "/login";

        if (isAuthenticated && isLoginRoute) {
            navigate("/dashboard/manage", { replace: true });
            return;
        }

        if (!isAuthenticated && !isLoginRoute) {
            navigate("/login", { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname]);

    return (
        <Fragment>
            {children}
        </Fragment>
    )
}